import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import AddTaskQBtn from "./AddTaskQBtn";
import AnswerOptions from "./AnswerOptions";
import RandomizeAOBlock from "./RandomizeAOBlock";
import { Dropdown } from "primereact/dropdown";
import { AnswerTypeOptions, TQDurations } from "../../../utils/constants";

const AddQuestionComponent = ({
  index,
  taskQuestion,
  updateQuestionItem,
  updateSubTQItemNestedPath,
  taskQuestions,
  radioButtons,
  handleAddQuesTask,
  showAddTQBtn = false,
  answerOptionText,
  handleShuffle,
  type,
  quesCount,
  isLocked = false,
  surveyType = "",
  taskIndex = null,
}) => {
  const {
    questionName,
    selectedQuestionOption,
    quesDuration,
    isError,
    errorMsg,
    isExtraction,
  } = taskQuestion;

  const getDurationVal = (optionVal) => {
    switch (optionVal) {
      case "open_ended_question":
        return 60;

      case "multiple_choice_single_select":
        return surveyType === "text" ? 15 : 30;

      case "multiple_choice_multi_select":
        return surveyType === "text" ? 30 : 45;

      case "rating_question":
        return surveyType === "text" ? 15 : 30;

      case "ranking_question":
        return surveyType === "text" ? 30 : 60;

      default:
        return 60;
    }
  };

  const addMoreOption = (optionType) => {
    let newAnserOptions = [
      {
        label: `Option ${taskQuestion[optionType].options.length + 1}`,
        value: "",
        isOptional: true,
        isError: false,
        errormsg: "",
      },
      {
        label: `Option ${taskQuestion[optionType].options.length + 2}`,
        value: "",
        isOptional: true,
        isError: false,
        errormsg: "",
      },
      {
        label: `Option ${taskQuestion[optionType].options.length + 3}`,
        value: "",
        isOptional: true,
        isError: false,
        errormsg: "",
      },
    ];

    if (type === "parent") {
      let questionOptionType = { ...taskQuestion[optionType] };
      questionOptionType.options = [
        ...questionOptionType.options,
        ...newAnserOptions,
      ];
      updateQuestionItem(optionType, questionOptionType);
    } else {
      updateSubTQItemNestedPath(`${optionType}.options`, [
        ...taskQuestion[optionType].options,
        ...newAnserOptions,
      ]);
    }
  };

  const updateOptionValueHandler = (optionType, optIndex, value) => {
    if (type === "parent") {
      let questionOptionType = { ...taskQuestion[optionType] };
      questionOptionType.options[optIndex].value = value;
      updateQuestionItem(optionType, questionOptionType);
    } else {
      updateSubTQItemNestedPath(
        `${optionType}.options.${optIndex}.value`,
        value,
      );
    }
  };

  const updateBulkTextHandler = (optionType, textValue) => {
    let questionOptionType = { ...taskQuestion[optionType] };
    questionOptionType.bulkAddText = textValue;
    updateQuestionItem(optionType, questionOptionType);
  };

  const updateIsBulkAddHandler = (optionType) => {
    let questionOptionType = { ...taskQuestion[optionType] };
    questionOptionType.isBulkAdd = !questionOptionType.isBulkAdd;
    updateQuestionItem(optionType, questionOptionType);
  };

  const updateSplitAnswersHandler = (optionType) => {
    let questionOptionType = { ...taskQuestion[optionType] };
    const textValues = questionOptionType.bulkAddText.split(",");
    const answerOpts = [...questionOptionType.options];
    if (textValues.length > answerOpts.length) {
      return false;
    } else {
      for (let [i, textValue] of textValues.entries()) {
        answerOpts[i].value = textValue;
      }

      if (type === "parent") {
        questionOptionType.options = [...answerOpts];
        questionOptionType.bulkAddText = "";
        updateQuestionItem(optionType, questionOptionType);
      } else {
        updateSubTQItemNestedPath(`${optionType}.options`, [...answerOpts]);
        updateSubTQItemNestedPath(`${optionType}.bulkAddText`, "");
      }
    }
  };

  const updateRandomizeAnsOptHandler = (optionType, randomizeAnsOptVal) => {
    if (type === "parent") {
      let questionOptionType = { ...taskQuestion[optionType] };
      questionOptionType.randomizeAnsOpt = randomizeAnsOptVal;
      updateQuestionItem(optionType, questionOptionType);
    } else {
      updateSubTQItemNestedPath(
        `${optionType}.randomizeAnsOpt`,
        randomizeAnsOptVal,
      );
    }
  };

  const getAnswerTypeIns = (answerType) => {
    switch (answerType) {
      case "text":
        return "Please explain in detail";

      case "audio":
        return "Please explain verbally";

      case "number":
        return "Please enter a number";

      default:
        return "Please explain in detail";
    }
  };

  const handleRatingScaleChange = (scaleValue, instructionText) => {
    if (type === "parent") {
      let ratingQuestion = { ...taskQuestion[selectedQuestionOption] };
      ratingQuestion.selectedScale = scaleValue;
      ratingQuestion.instructions = instructionText;
      updateQuestionItem(selectedQuestionOption, ratingQuestion);
    } else {
      updateSubTQItemNestedPath(
        `${selectedQuestionOption}.selectedScale`,
        scaleValue,
      );
      updateSubTQItemNestedPath(
        `${selectedQuestionOption}.instructions`,
        instructionText,
      );
    }
  };

  const handleInstructionChange = (instructionValue) => {
    if (type === "parent") {
      let questionItem = { ...taskQuestion[selectedQuestionOption] };
      questionItem.instructions = instructionValue;
      updateQuestionItem(selectedQuestionOption, questionItem);
    } else {
      updateSubTQItemNestedPath(
        `${selectedQuestionOption}.instructions`,
        instructionValue,
      );
    }
  };

  const checkChildExtractedQuestion = () => {
    const exractedQuestions = taskQuestions?.filter(
      (tq) =>
        tq?.isExtraction &&
        (tq?.extractedQId === taskQuestion?.qId ||
          tq?.extractedQId === taskQuestion?.question_id),
    );

    if (exractedQuestions?.length > 0) {
      return true;
    }

    return false;
  };

  return (
    <div>
      <div className="d-flex mt-2">
        <div className="w-100">
          <InputText
            id={`questionName-${quesCount}`}
            className={`w-100 inputField ${isError ? "error-input" : ""}`}
            autoComplete="off"
            value={questionName}
            name="questionName"
            onChange={(e) => updateQuestionItem("questionName", e.target.value)}
          />
          {isError ? (
            <div className="text-start fs-14 text-danger">{errorMsg}</div>
          ) : (
            ""
          )}
        </div>
        <div className="shift-place-icons ms-3">
          <i
            className="pi pi-angle-up cursor-pointer"
            onClick={() => {
              if (isLocked) {
                return false;
              }
              handleShuffle("up", index, taskIndex);
            }}
            disabled={isLocked}
          ></i>
          <span
            style={{
              borderBottom: "1px solid #9E9E9E",
              borderTop: "1px solid #9E9E9E",
              width: "16px",
              display: "block",
            }}
          ></span>
          <i
            className="pi pi-angle-down cursor-pointer"
            onClick={() => {
              if (isLocked) {
                return false;
              }
              handleShuffle("down", index, taskIndex);
            }}
            disabled={isLocked}
          ></i>
        </div>
      </div>

      <div className="radio-buttons d-flex align-items-center flex-wrap mt-2">
        {radioButtons.map((radioButton, idx) => (
          <div
            className="me-3 d-flex align-items-center mb-2"
            key={quesCount + "-" + idx}
          >
            {/* <RadioButton
              inputId={`radioButton.label-${quesCount}-${idx}`}
              name={`radioButton-label`}
              value={radioButton.value}
              onChange={(e) => {
                const durationVal = getDurationVal(e.value);
                updateQuestionItem("selectedQuestionOption", e.value);
                updateQuestionItem("quesDuration", durationVal);
              }}
              checked={selectedQuestionOption === radioButton.value}
            />
            <label htmlFor={`radioButton.label-${index}`} className="ms-2">
              {radioButton.label}
            </label> */}
            <div className="form-check d-flex align-items-center">
              <input
                className="form-check-input"
                type="radio"
                name={`radioButton.label-${quesCount}-${idx}`}
                id={`radioButton.label-${quesCount}-${idx}`}
                value={radioButton.value}
                onChange={(e) => {
                  const durationVal = getDurationVal(e.target.value);
                  updateQuestionItem("selectedQuestionOption", e.target.value);
                  updateQuestionItem("quesDuration", durationVal);
                }}
                checked={selectedQuestionOption === radioButton.value}
                disabled={
                  isLocked || isExtraction || checkChildExtractedQuestion()
                }
              />
              <label
                className="form-check-label mt-1 ms-2"
                htmlFor={`radioButton.label-${quesCount}-${idx}`}
              >
                {radioButton.label}
              </label>
            </div>
          </div>
        ))}
      </div>

      {selectedQuestionOption === "open_ended_question" ? (
        <>
          <div className="row my-3">
            <div className="col-md-2 col-6">
              {surveyType === "text" ? (
                <>
                  <label className="form-label mb-1">Select Answer Type</label>
                  <Dropdown
                    value={
                      taskQuestion[selectedQuestionOption]?.answerType
                        ?.selectedType
                    }
                    onChange={(e) => {
                      const InstructionStr = getAnswerTypeIns(e.value);
                      let openEndedQuestion = {
                        ...taskQuestion[selectedQuestionOption],
                      };
                      if (type === "parent") {
                        openEndedQuestion.answerType.selectedType = e.value;
                        updateQuestionItem(
                          "answerType",
                          openEndedQuestion.answerType,
                        );
                        openEndedQuestion.instructions = InstructionStr;
                        updateQuestionItem(
                          selectedQuestionOption,
                          openEndedQuestion,
                        );
                      } else {
                        updateSubTQItemNestedPath(
                          `${selectedQuestionOption}.answerType`,
                          {
                            ...openEndedQuestion.answerType,
                            selectedType: e.value,
                          },
                        );
                        updateSubTQItemNestedPath(
                          `${selectedQuestionOption}.instructions`,
                          InstructionStr,
                        );
                      }
                    }}
                    options={AnswerTypeOptions}
                    optionLabel="name"
                    placeholder="Select answer type"
                    className="w-100 inputField"
                    disabled={isLocked}
                  />
                </>
              ) : (
                ""
              )}
              {taskQuestion[selectedQuestionOption]?.answerTypeError ? (
                <div className="text-start fs-14 text-danger">
                  {taskQuestion[selectedQuestionOption]?.answerTypeError}
                </div>
              ) : (
                ""
              )}
            </div>

            {/* {taskQuestion[selectedQuestionOption]?.answerType?.selectedType === "time" ? (
              <div className="col-md-3 col-6 ps-4">
                <div className="form-label mb-2">Select time option</div>
                <RadioButton
                  className="mt-1"
                  inputId={"time-opt-date"}
                  name={"time-opt-date"}
                  value={1}
                  onChange={(e) => {
                    if (type === "parent") {
                      taskQuestion[selectedQuestionOption].answerType.selectedValue =
                        e.target.value;
                      updateQuestionItem(
                        "answerType",
                        taskQuestion[selectedQuestionOption].answerType,
                      );
                    } else {
                      updateSubTQItemNestedPath(
                        `${selectedQuestionOption}.answerType`,
                        {
                          ...taskQuestion[selectedQuestionOption].answerType,
                          selectedValue: e.target.value,
                        },
                      );
                    }
                  }}
                  checked={taskQuestion[selectedQuestionOption].answerType.selectedValue === 1}
                  disabled={isLocked}
                />
                <label htmlFor={"one-to-five"} className="ms-2">
                  {"Date"}
                </label>
                <RadioButton
                  className="ms-3 mt-1"
                  inputId={"date_time"}
                  name={"date_time"}
                  value={2}
                  onChange={(e) => {
                    if (type === "parent") {
                      taskQuestion[selectedQuestionOption].answerType.selectedValue =
                        e.target.value;
                      updateQuestionItem(
                        "answerType",
                        taskQuestion[selectedQuestionOption].answerType,
                      );
                    } else {
                      updateSubTQItemNestedPath(
                        `${selectedQuestionOption}.answerType`,
                        {
                          ...taskQuestion[selectedQuestionOption].answerType,
                          selectedValue: e.target.value,
                        },
                      );
                    }
                  }}
                  checked={taskQuestion[selectedQuestionOption].answerType.selectedValue === 2}
                  disabled={isLocked}
                />
                <label htmlFor={"one-to-ten"} className="ms-2">
                  {"Date & time"}
                </label>
              </div>
            ) : (
              ""
            )} */}
          </div>

          <div className="fs-14 mb-1 mt-2">
            Instructions for {index + 1} Question:
          </div>
          <InputText
            id={`instruction-open-ended-${quesCount}`}
            className={`w-100 inputField ${taskQuestion?.[selectedQuestionOption]?.isInstructionError ? "error-input" : ""}`}
            autoComplete="off"
            value={taskQuestion?.[selectedQuestionOption]?.instructions}
            name="open-ended-instructions"
            onChange={(e) => handleInstructionChange(e.target.value)}
          />
          {taskQuestion?.[selectedQuestionOption]?.isInstructionError ? (
            <div className="text-start fs-14 text-danger">
              {taskQuestion?.[selectedQuestionOption]?.instructionErrormsg}
            </div>
          ) : (
            ""
          )}
          {!showAddTQBtn || index === taskQuestions?.length - 1 ? (
            ""
          ) : (
            <AddTaskQBtn
              handleAddQuesTask={handleAddQuesTask}
              isLocked={isLocked}
            />
          )}
        </>
      ) : (
        ""
      )}

      {selectedQuestionOption === "multiple_choice_single_select" ? (
        <>
          <div className="d-flex align-items-center my-2">
            <div className="fs-14 flex-fill">
              {!isExtraction ? (
                <span>{answerOptionText}. Answer Options:</span>
              ) : (
                ""
              )}
            </div>
            <div className="flex-fill">
              <RandomizeAOBlock
                randomizeAnsOpt={
                  taskQuestion?.[selectedQuestionOption]?.randomizeAnsOpt
                }
                updateRandomizeAnsOpt={(randomizeAnsOptVal) => {
                  updateRandomizeAnsOptHandler(
                    selectedQuestionOption,
                    randomizeAnsOptVal,
                  );
                }}
                isLocked={isLocked}
              />
            </div>
          </div>
          {!isExtraction ? (
            <AnswerOptions
              index={index}
              answerOptions={taskQuestion?.[selectedQuestionOption]?.options}
              addMoreOption={() => addMoreOption(selectedQuestionOption)}
              updateOptionValue={(optIndex, value) => {
                updateOptionValueHandler(
                  selectedQuestionOption,
                  optIndex,
                  value,
                );
              }}
              isBulkAdd={taskQuestion?.[selectedQuestionOption]?.isBulkAdd}
              bulkAddText={taskQuestion?.[selectedQuestionOption]?.bulkAddText}
              handleBulkText={(textValue) => {
                updateBulkTextHandler(selectedQuestionOption, textValue);
              }}
              handleIsBulkAdd={() => {
                updateIsBulkAddHandler(selectedQuestionOption);
              }}
              handleSplitAnswers={() => {
                updateSplitAnswersHandler(selectedQuestionOption);
              }}
              isLocked={isLocked}
            />
          ) : (
            ""
          )}
          <div className="fs-14 mb-1 mt-4">
            Instructions for {index + 1} Question:
          </div>
          <InputText
            id={`single-select-instruction-${quesCount}`}
            className={`w-100 inputField ${taskQuestion?.[selectedQuestionOption]?.isInstructionError ? "error-input" : ""}`}
            autoComplete="off"
            value={taskQuestion?.[selectedQuestionOption]?.instructions}
            name="single-select-instructions"
            onChange={(e) => handleInstructionChange(e.target.value)}
          />
          {taskQuestion?.[selectedQuestionOption]?.isInstructionError ? (
            <div className="text-start fs-14 text-danger">
              {taskQuestion?.[selectedQuestionOption]?.instructionErrormsg}
            </div>
          ) : (
            ""
          )}
          {!showAddTQBtn || index === taskQuestions.length - 1 ? (
            ""
          ) : (
            <AddTaskQBtn
              handleAddQuesTask={handleAddQuesTask}
              isLocked={isLocked}
            />
          )}
        </>
      ) : (
        ""
      )}

      {selectedQuestionOption === "multiple_choice_multi_select" ? (
        <>
          <div className="d-flex align-items-center my-2">
            <div className="fs-14 flex-fill">
              {!isExtraction ? <span>{index + 1}. Answer Options:</span> : ""}
            </div>
            <div className="flex-fill">
              <RandomizeAOBlock
                randomizeAnsOpt={
                  taskQuestion?.[selectedQuestionOption]?.randomizeAnsOpt
                }
                updateRandomizeAnsOpt={(randomizeAnsOptVal) => {
                  updateRandomizeAnsOptHandler(
                    selectedQuestionOption,
                    randomizeAnsOptVal,
                  );
                }}
                isLocked={isLocked}
              />
            </div>
          </div>
          {!isExtraction ? (
            <AnswerOptions
              index={index}
              answerOptions={taskQuestion?.[selectedQuestionOption]?.options}
              addMoreOption={() => addMoreOption(selectedQuestionOption)}
              updateOptionValue={(optIndex, value) => {
                updateOptionValueHandler(
                  selectedQuestionOption,
                  optIndex,
                  value,
                );
              }}
              isBulkAdd={taskQuestion?.[selectedQuestionOption]?.isBulkAdd}
              bulkAddText={taskQuestion?.[selectedQuestionOption]?.bulkAddText}
              handleBulkText={(textValue) => {
                updateBulkTextHandler(selectedQuestionOption, textValue);
              }}
              handleIsBulkAdd={() => {
                updateIsBulkAddHandler(selectedQuestionOption);
              }}
              handleSplitAnswers={() => {
                updateSplitAnswersHandler(selectedQuestionOption);
              }}
              isLocked={isLocked}
            />
          ) : (
            ""
          )}
          <div className="fs-14 mb-1 mt-4">
            Instructions for {index + 1} Question:
          </div>
          <InputText
            id={`instruction-multi-select-${quesCount}`}
            className={`w-100 inputField ${taskQuestion?.[selectedQuestionOption]?.isInstructionError ? "error-input" : ""}`}
            autoComplete="off"
            value={taskQuestion?.[selectedQuestionOption]?.instructions}
            name="multi-select-instructions"
            onChange={(e) => handleInstructionChange(e.target.value)}
          />
          {taskQuestion?.[selectedQuestionOption]?.isInstructionError ? (
            <div className="text-start fs-14 text-danger">
              {taskQuestion?.[selectedQuestionOption]?.instructionErrormsg}
            </div>
          ) : (
            ""
          )}
          {!showAddTQBtn || index === taskQuestions.length - 1 ? (
            ""
          ) : (
            <AddTaskQBtn
              handleAddQuesTask={handleAddQuesTask}
              isLocked={isLocked}
            />
          )}
        </>
      ) : (
        ""
      )}

      {selectedQuestionOption === "rating_question" ? (
        <>
          {!isExtraction ? (
            <>
              <div className="fs-14 mb-1 mt-2">Scale being from</div>
              <div className="d-flex align-items-center">
                <RadioButton
                  inputId={"one-to-five"}
                  name={"one-to-five"}
                  value={"5"}
                  onChange={(e) =>
                    handleRatingScaleChange(
                      e.target.value,
                      "With 5 being the best",
                    )
                  }
                  checked={
                    taskQuestion[selectedQuestionOption]?.selectedScale === "5"
                  }
                  disabled={isLocked}
                />
                <label htmlFor={"one-to-five"} className="ms-2">
                  {"1 - 5"}
                </label>
                <RadioButton
                  inputId={"one-to-ten"}
                  name={"one-to-ten"}
                  value={"10"}
                  onChange={(e) =>
                    handleRatingScaleChange(
                      e.target.value,
                      "With 10 being the best",
                    )
                  }
                  checked={
                    taskQuestion[selectedQuestionOption]?.selectedScale === "10"
                  }
                  className="ms-3"
                  disabled={isLocked}
                />
                <label htmlFor={"one-to-ten"} className="ms-2">
                  {"1 - 10"}
                </label>
              </div>
            </>
          ) : (
            ""
          )}

          <div className="fs-14 mb-1 mt-2">
            Instructions for {index + 1} Question:
          </div>
          <InputText
            id={`instruction-rating-question-${quesCount}`}
            className={`w-100 inputField ${taskQuestion?.[selectedQuestionOption]?.isInstructionError ? "error-input" : ""}`}
            autoComplete="off"
            value={taskQuestion[selectedQuestionOption]?.instructions}
            name="rating-question-instructions"
            onChange={(e) => handleInstructionChange(e.target.value)}
          />
          {taskQuestion?.[selectedQuestionOption]?.isInstructionError ? (
            <div className="text-start fs-14 text-danger">
              {taskQuestion?.[selectedQuestionOption]?.instructionErrormsg}
            </div>
          ) : (
            ""
          )}
          {!showAddTQBtn || index === taskQuestions.length - 1 ? (
            ""
          ) : (
            <AddTaskQBtn
              handleAddQuesTask={handleAddQuesTask}
              isLocked={isLocked}
            />
          )}
        </>
      ) : (
        ""
      )}

      {selectedQuestionOption === "ranking_question" ? (
        <>
          {!isExtraction ? (
            <>
              <div className="fs-14 mb-2">{index + 1}. Answer Options:</div>
              <AnswerOptions
                index={index}
                answerOptions={taskQuestion?.[selectedQuestionOption]?.options}
                addMoreOption={() => addMoreOption(selectedQuestionOption)}
                updateOptionValue={(optIndex, value) => {
                  updateOptionValueHandler(
                    selectedQuestionOption,
                    optIndex,
                    value,
                  );
                }}
                isBulkAdd={taskQuestion?.[selectedQuestionOption]?.isBulkAdd}
                bulkAddText={
                  taskQuestion?.[selectedQuestionOption]?.bulkAddText
                }
                handleBulkText={(textValue) => {
                  updateBulkTextHandler(selectedQuestionOption, textValue);
                }}
                handleIsBulkAdd={() => {
                  updateIsBulkAddHandler(selectedQuestionOption);
                }}
                handleSplitAnswers={() => {
                  updateSplitAnswersHandler(selectedQuestionOption);
                }}
                isLocked={isLocked}
              />
            </>
          ) : (
            ""
          )}

          <div className="fs-14 mb-1 mt-2">
            Instructions for {index + 1} Question:
          </div>
          <InputText
            id={`instruction-ranking-question-${quesCount}`}
            className={`w-100 inputField ${taskQuestion?.[selectedQuestionOption]?.isInstructionError ? "error-input" : ""}`}
            autoComplete="off"
            value={taskQuestion[selectedQuestionOption]?.instructions}
            name="ranking-question-instructions"
            onChange={(e) => handleInstructionChange(e.target.value)}
          />
          {taskQuestion?.[selectedQuestionOption]?.isInstructionError ? (
            <div className="text-start fs-14 text-danger">
              {taskQuestion?.[selectedQuestionOption]?.instructionErrormsg}
            </div>
          ) : (
            ""
          )}
          {!showAddTQBtn || index === taskQuestions.length - 1 ? (
            ""
          ) : (
            <AddTaskQBtn
              handleAddQuesTask={handleAddQuesTask}
              isLocked={isLocked}
            />
          )}
        </>
      ) : (
        ""
      )}

      <div className="row my-3">
        <div className="col-md-3">
          <label className="form-label mb-1 fs-14">Duration:</label>
          <Dropdown
            value={quesDuration}
            onChange={(e) => updateQuestionItem("quesDuration", e.value)}
            options={TQDurations}
            optionLabel="name"
            placeholder="Select duration"
            className="w-100 inputField"
            disabled={isLocked}
          />
        </div>
      </div>
    </div>
  );
};

export default AddQuestionComponent;
